import { create } from "zustand";
import { toast } from "react-toastify";

/* =======================
   TYPE (FORM)
======================= */
export type LanguageForm = {
  languageId: string | number;
  profiencyId: string | number;
};

/* =======================
   STORE
======================= */
type LanguageState = {
  loading: boolean;
  updateLanguages: (data: LanguageForm[]) => Promise<boolean>;
};

const getAccessToken = (): string | null => {
  if (typeof window === "undefined") return null;

  try {
    const raw = localStorage.getItem("auth-storage");
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    return parsed?.state?.accessToken || null;
  } catch (e) {
    console.error("❌ Failed to parse auth token:", e);
    return null;
  }
};

export const useLanguageStore = create<LanguageState>((set) => ({
  loading: false,

  updateLanguages: async (data) => {
    try {
      set({ loading: true });

      const token = getAccessToken();
      if (!token) throw new Error("No access token");

      const payload = {
        languages: data.map((l) => ({
          language_id: Number(l.languageId),
          proficiency_id: Number(l.profiencyId),
        })),
      };

      const res = await fetch(
        "https://admin.talentlinkindo.com/api/candidate/languages",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );

      if (!res.ok) throw new Error("Update language failed");

      toast.success("Languages updated successfully");
      return true;
    } catch (err) {
      console.error(err);
      toast.error("Failed to update languages");
      return false;
    } finally {
      set({ loading: false });
    }
  },
}));
